// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-mesh-base-info-base-info-9ae73 .icloud-ui-card-field-title{width:120px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base-info": "service-mesh-base-info-base-info-9ae73",
	"baseInfo": "service-mesh-base-info-base-info-9ae73"
};
export default ___CSS_LOADER_EXPORT___;
